import Selector from './Selector.vue';

export * from './types';
export default Selector;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/selector/index.ts